import { TDictionary } from '@/common/types/dictionary';
import { TArrayAxiosResponse } from '@/common/types/response';

import { TPermissionsStoreState } from './types';

export function setPermissions(state: TPermissionsStoreState, res: TArrayAxiosResponse<TDictionary>) {
  state.permissions = res.data.items;
}
